import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import moment, { Moment } from 'moment';
import { SingleDatePicker } from 'react-dates';
import noop from '@gik/core/utils/noop';
import SvgIcon from '../SvgIcon';
import { dateDisplayFormat } from '@gik/l10n';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/CustomHooks';

const blockName = 'date-picker';

export interface IDatePickerProps {
  className?: string;
  placeholder?: string;
  value: Moment;
  name?: string;
  startDate?: Moment;
  onChange(date: Moment): void;
  onBlur?(): void;
  onFocus?(): void;
}

export default function DatePicker({
  className,
  value,
  name,
  placeholder,
  startDate,
  onChange = noop,
  onBlur = noop,
  onFocus = noop,
}: React.PropsWithChildren<IDatePickerProps>) {
  const bem = bemBlock(blockName);
  const [date, setDate] = React.useState<Moment>(value);
  const [focused, setFocused] = React.useState<boolean>();

  const isMdUp = useBreakpoint(Breakpoint.MD);

  function handleDateChange(date: Moment) {
    setDate(date);
    onChange(date);
  }
  function handleFocusChange(data: { focused: boolean }) {
    setFocused(data.focused);
    data.focused ? onFocus() : onBlur();
  }

  // block days before startDate
  function isDayBlocked(day: Moment) {
    if (startDate) {
      return day.isBefore(startDate);
    }
    return false;
  }

  React.useEffect(() => {
    if (value) setDate(moment(value));
  }, [value]);

  return (
    <div className={bem(null, null, className)}>
      <SingleDatePicker
        readOnly
        placeholder={placeholder}
        id={name || `${blockName}${DatePicker.counter++}`} // PropTypes.string.isRequired,
        date={date} // momentPropTypes.momentObj or null
        onDateChange={handleDateChange} // PropTypes.func.isRequired
        focused={focused} // PropTypes.bool
        onFocusChange={handleFocusChange} // PropTypes.func.isRequired
        hideKeyboardShortcutsPanel={true}
        enableOutsideDays={true}
        withPortal={true}
        numberOfMonths={isMdUp ? 2 : 1}
        displayFormat={dateDisplayFormat}
        isDayBlocked={isDayBlocked}
        navNext={<SvgIcon className="gik-datepicker-btn-next" name="ChevronRight" />}
        navPrev={<SvgIcon className="gik-datepicker-btn-prev" name="ChevronLeft" />}
      />
    </div>
  );
}

DatePicker.counter = 0;
